var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPharmacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 32,
    viewBox: "0 0 87 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.8336 0.600006H17.72C8.41399 0.600006 0.799988 7.15201 0.799988 15.9C0.799988 24.648 8.41399 31.2 17.72 31.2H69.8336C79.136 31.2 86.75 24.6462 86.75 15.9C86.75 7.15201 79.136 0.600006 69.8336 0.600006ZM69.839 27.6H44V4.20001H69.839C76.7006 4.20001 82.3202 9.44701 82.3202 15.9C82.3202 22.353 76.7024 27.6 69.839 27.6Z",
    fill: "#585864"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacy);
export default __webpack_public_path__ + "static/media/pharmacy.0e11d3d86da340f4e0e96a26781b7f16.svg";
export { ForwardRef as ReactComponent };